export default {
  install (Vue) {
    Vue.mixin({
      methods: {
        // 这是跳转的方法
        goBackMixin () {
          let oldHref = this.$route.fullPath
          this.$router.go(-1)
          // 兼容没有反应强制跳转
          let timer = setTimeout(() => {
            let newHref = this.$route.fullPath
            if (newHref === oldHref) this.$router.push('/')
            clearTimeout(timer)
          }, 50)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixin/common.js